













import { Vue, Component, Prop } from "vue-property-decorator";
import CButton from "../../basics/buttons/CButton.vue";
import SingleFileInput from "@/basics/inputs/SingleFileInput.vue";
import { parse } from "@/lib/csv";

export interface UploadEvent {
  file: File;
  text?: string;
}

export interface ParseCheckErrorEvent {
  file: File;
}

@Component({
  components: { CButton, SingleFileInput }
})
export default class UploadCsvFile extends Vue {
  file: File | null = null;

  @Prop({ type: String, required: false }) checkToken?: string;

  get filePath(): string {
    if (!this.file) {
      return "";
    }
    return this.file.name;
  }

  async upload() {
    const file = this.file!;
    const content = await parse(file, this.checkToken);
    if (!content) {
      this.$emit("parseCheckError", { file } as ParseCheckErrorEvent);
      return;
    }
    const { text } = content;
    const result: UploadEvent = { file, text };
    this.$emit("upload", result);
  }
}
